/*
 *
 * Coupon constants
 *
 */

export const FETCH_COUPON = 'src/Coupon/FETCH_COUPON';
export const FETCH_COUPONS = 'src/Coupon/FETCH_COUPONS';
export const FETCH_USER_COUPONS = 'src/Coupon/FETCH_USER_COUPONS';
export const COUPON_CHANGE = 'src/Coupon/COUPON_CHANGE';
export const COUPON_EDIT_CHANGE = 'src/Coupon/COUPON_EDIT_CHANGE';
export const SET_COUPON_FORM_ERRORS = 'src/Coupon/SET_COUPON_FORM_ERRORS';
export const SET_COUPON_FORM_EDIT_ERRORS = 'src/Coupon/SET_COUPON_FORM_EDIT_ERRORS';
export const RESET_COUPON = 'src/Coupon/RESET_COUPON';
export const ADD_COUPON = 'src/Coupon/ADD_COUPON';
export const REMOVE_COUPON = 'src/Coupon/REMOVE_COUPON';
export const SET_COUPONS_LOADING = 'src/Coupon/SET_COUPONS_LOADING';
export const FETCH_COUPONS_SELECT = 'src/Coupon/FETCH_COUPONS_SELECT';